import {Component, OnInit, Input, HostListener, Output, EventEmitter, OnDestroy} from '@angular/core';
import {DataService} from '../../../_services/data.service';
import {Item} from '../../../_core/_interface/item';
import {Building} from '../../../_core/_interface/building';
import {ActivatedRoute, Router} from '@angular/router';
import {slideRightUp} from 'src/app/animations';
import {SelseforceCommunicationService} from 'src/app/_services/selseforce-communication.service';
import {AuthService} from 'src/app/_services/auth.service';
import {User} from 'src/app/_core/_interface/user';
import {firstValueFrom, lastValueFrom, Subscription} from "rxjs";
import * as _ from 'lodash';
import {BuildingFlat} from "../../../_core/_interface/buildingFlat";

declare var ResizeObserver;

@Component({
    selector: 'app-view-floor-test',
    templateUrl: './view-floor-test.component.html',
    styleUrls: ['./view-floor-test.component.scss'],
    animations: [
        slideRightUp
    ]
})
export class ViewFloorTestComponent implements OnInit, OnDestroy {
    @Input() buildId: string;
    @Input() buildUid: string;

    public floors: any[];
    public allFlats: BuildingFlat[] = [];
    public filteredFlats: BuildingFlat[] = [];
    public compId;
    public itemToEdit: Item;
    public noItems;
    public build: Building;
    private resizeTimeout;
    public widthDragZone: number;
    public compositeDesign: boolean = false;
    public unika: boolean = false;
    public selectedFloorId: string;
    private roomsFilterSubscription: Subscription;
    private prototypeSubscription: Subscription;
    private flatStatusSubscription: Subscription;
    private floorsNumbersSubscription: Subscription;
    private routeUrlSubscription: Subscription;
    private refreshTokenSubscription: Subscription;
    private getAccessTokenSubscription: Subscription;
    private queryDataSubscription: Subscription;
    private filterProp: any = {
        numRooms: 0,
        status: '',
        minFloor: 0,
        maxFloor: 0
    };

    initialFloors: any;

    // @Input()
    // filter: any = {};

    user: User;
    collection = 'buildings/';
    records: any;
    counter: number;
    isUpdate: boolean = false;

    constructor(private dataService: DataService,
                private route: ActivatedRoute,
                private selseF: SelseforceCommunicationService,
                private auth: AuthService,
                private router: Router,
    ) {
        this.compId = this.route.snapshot.params.id;
    }

    async ngOnInit() {
        this.user = this.auth.currentUserValue;
        if (!this.floors) {
            this.counter = 0;
            const building: Building | null = (await firstValueFrom(this.dataService.getSpecBuilding(this.buildUid)))?.[0] || null;
            const projUid = this.route.snapshot.paramMap.get('idp');
            const prototypes = await firstValueFrom(this.dataService.getFlatPrototypesByProjUid(projUid));
            let floors = building.floors.filter(n => n).map(({floor, withDrawing}) => ({
                ...floor,
                ...(withDrawing !== undefined ? {withDrawing} : {})
            }));
            floors.forEach(floor => {
                floor.flats.forEach((flat) => {
                    flat.floorId = floor.id;
                    flat.panoramaView = floor.panoramaView;
                    flat.withDrawing = floor.withDrawing ? floor.withDrawing : false;
                    const prototypeExist = prototypes.find((prototype) => prototype.uid === flat.faltPrototype);
                    if (prototypeExist) {
                        flat.faltPrototypeId = prototypeExist.id;
                        if (prototypeExist.flatInterior) {
                            flat.isVirtualTour = true;
                        }
                    }
                    this.allFlats.push(flat);
                })
                //floor.flats = _.orderBy(floor.flats, ['number'], ['asc']);
            })
            //console.log(_.sortBy(floors, 'number'))
            floors = _.orderBy(floors, ['number', 'ranking'], ['desc', 'asc']);
            this.allFlats = _.orderBy(this.allFlats, [(flat: BuildingFlat) => {
                if(typeof flat.number === "number") {
                    return flat.number;
                } else {
                    const match = flat.number.match(/\d+/);
                    return match ? parseInt(match[0]) : 0;
                }
            }], ['asc']);
            this.filteredFlats = this.allFlats;
            console.log('filteredFlats >>>>> ', this.filteredFlats);
            this.initialFloors = JSON.parse(JSON.stringify(floors));
            this.floors = floors;
            this.dataService.saveItemsToFilter(this.filteredFlats);
            // console.log("SELSEforce===============================", this.selseF.refreshTokenAndGetResponse());
            if (building.crmId && this.floors[0] && building.crmType !== 'salseForceMerkazHair') {
                this.refreshTokenSubscription = this.selseF.refreshTokenAndGetResponse(building.crmId).subscribe({
                    next: (propertiesResponse) => {
                        console.log("this.records", this.records);
                        this.records = propertiesResponse.records;
                        //console.log(this.records);
                        // Process the properties data here
                        floors.forEach(floorHolder => {
                            floorHolder.flats.forEach(flat => {
                                let foundStatus = this.records.filter(status => +status?.Property_Number__c === flat.number);
                                if (foundStatus && foundStatus.length > 0) {
                                    // console.log("foundStatus.Asset_Purchasing_Status__c", foundStatus[0].Asset_Purchasing_Status__c);

                                    if (foundStatus[0].Asset_Purchasing_Status__c === 'חוזה נחתם') {
                                        if (flat.status !== "sold") {
                                            this.isUpdate = true;
                                            flat.status = "sold"
                                        }
                                    } else if (foundStatus[0].Asset_Purchasing_Status__c === 'לא למכירה') {
                                        if (flat.status !== "notForSale") {
                                            this.isUpdate = true;
                                            flat.status = "notForSale"
                                        }
                                    } else if (foundStatus[0].Asset_Purchasing_Status__c === 'הסכם רכישה') {
                                        if (flat.status !== "waiting") {
                                            this.isUpdate = true;
                                            flat.status = "waiting"
                                        }
                                    } else if (foundStatus[0].Asset_Purchasing_Status__c === 'זמין למכירה') {
                                        if (flat.status !== "free") {
                                            this.isUpdate = true;
                                            flat.status = "free"
                                        }
                                    }

                                }
                            });
                        })
                        let now: any = new Date();
                        if (building.updateDate && this.isUpdate) {
                            let currentUpdateDate: any = building.updateDate;
                            currentUpdateDate = convertTimestampToDate(currentUpdateDate)
                            let diff = Math.abs(currentUpdateDate - now)
                            if (diff > 100000) {
                                building.updateDate = now;

                                this.dataService.updateItem(building, 'buildings/');
                            }
                        } else {
                            building.updateDate = now;
                            if (this.isUpdate) {
                                this.dataService.updateItem(building, 'buildings/');
                            }
                            return;
                        }

                        function convertTimestampToDate(timestamp): Date {
                            // Convert seconds to milliseconds and add nanoseconds converted to milliseconds
                            const dateInMilliseconds = (timestamp.seconds * 1000) + (timestamp.nanoseconds / 1000000);
                            return new Date(dateInMilliseconds);
                        }
                    },
                    error: (error) => {
                        console.error('Error fetching properties:', error);
                    }
                });
                // items[0].floors = this.items;
                // this.dataService.updateItem(items[0], 'buildings/');
                // salseForceMerkazHair
            }
            if (this.user) {
                if (building.crmId && this.floors[0] && building.crmType === 'salseForceMerkazHair' && ((this.user.roles.editor && this.user.compId === this.compId) || this.user.roles.admin)) {
                    this.getAccessTokenSubscription = this.selseF.getAccessToken(building.crmClientId, building.crmSecret, building.crmUsername, building.crmPassword, building.tokenUrl).subscribe({
                        next: (tokenResponse) => {
                            const accessToken = tokenResponse.access_token;
                            let str = building.crmId;

                            const replaceQuotes = building.crmId.replace(/"/g, "'");

                            this.queryDataSubscription = this.selseF.queryData(accessToken, building.queryUrl).subscribe({
                                next: (propertiesResponse) => {
                                    console.log("this", this);
                                    this.records = propertiesResponse.records;

                                    // Process the properties data here
                                    floors.forEach(floorHolder => {
                                        floorHolder.flats.forEach(flat => {
                                            let foundStatus = this.records.filter(status => +status?.Apt_No__c === flat.number);
                                            if (foundStatus && foundStatus[0]) {
                                                //console.log("foundStatus.Asset_Purchasing_Status__c", foundStatus[0].Asset_Status__c);
                                                if (foundStatus[0].Asset_Status__c === 'Sold') {
                                                    if (flat.status !== "sold") {
                                                        this.isUpdate = true;
                                                        flat.status = "sold"
                                                    }
                                                } else if (foundStatus[0].Asset_Status__c === "Blocked" || foundStatus[0].Asset_Status__c === "Owner apt") {
                                                    if (flat.status !== "notForSale") {
                                                        this.isUpdate = true;
                                                        flat.status = "notForSale"
                                                    }
                                                } else if (foundStatus[0].Asset_Status__c === "Registered") {
                                                    if (flat.status !== "waiting") {
                                                        this.isUpdate = true;
                                                        flat.status = "waiting"
                                                    }
                                                }
                                            }
                                        });
                                    })
                                    let now: any = new Date();
                                    if (this.isUpdate) {
                                        let currentUpdateDate: any = building.updateDate;
                                        currentUpdateDate = convertTimestampToDate(currentUpdateDate)
                                        let diff = Math.abs(currentUpdateDate - now)
                                        // if (diff > 100000) {
                                        building.updateDate = now;

                                        this.dataService.updateItem(building, 'buildings/');
                                        this.build = building;
                                        // }
                                    } else {
                                        building.updateDate = now;
                                        // return;
                                        if (this.isUpdate) {
                                            this.dataService.updateItem(building, 'buildings/');
                                            this.build = building;
                                        }
                                    }

                                    function convertTimestampToDate(timestamp): Date {
                                        // Convert seconds to milliseconds and add nanoseconds converted to milliseconds
                                        const dateInMilliseconds = (timestamp.seconds * 1000) + (timestamp.nanoseconds / 1000000);
                                        return new Date(dateInMilliseconds);
                                    }
                                },
                                error: (error) => {
                                    console.error('Error querying data:', error);
                                },
                                complete: () => {
                                    //console.log('Query complete');
                                }
                            });
                        },
                        error: (error) => {
                            console.error('Error getting access token:', error);
                        },
                        complete: () => {
                            //console.log('Token request complete');
                        }
                    });
                }
            }

            // Property_Number__c
            // Asset_Purchasing_Status__c

            this.build = building;
            //building.floors = building.floors.filter(n => n);
            const floorsNumber = this.initFloorsF();

            if (floorsNumber[0] === "") {
                floorsNumber[0] = 0;
            }
            this.filterProp = {
                numRooms: 0,
                status: '',
                currentPrototype: '',
                fromFloor: floorsNumber[0],
                untilFloor: floorsNumber[floorsNumber.length - 1]
            };
        }

        this.routeUrlSubscription = this.route.url.subscribe(segment => {
            segment.values;
            if (segment.length > 3) {
                for (let i = 0; segment.length > i; i++) {
                    if (segment[i].path === 'n') {
                        this.compositeDesign = true;
                    } else if (segment[i].path === 'u') {
                        this.compositeDesign = true;
                        this.unika = true;
                    }
                }
            }
        })

        this.roomsFilterSubscription = this.dataService.numRoomsFilter.subscribe(item => {
            this.filterProp.numRooms = item;
            this.filtering();
        })
        this.prototypeSubscription = this.dataService.currentPrototype.subscribe(item => {
            this.filterProp.currentPrototype = item;
            this.filtering();
        })
        this.flatStatusSubscription = this.dataService.flatStatusClass.subscribe(item => {
            this.filterProp.status = item;
            this.filtering();
        })
        this.floorsNumbersSubscription = this.dataService.floorsNumbers.subscribe(item => {
            this.filterProp.fromFloor = item[0];
            this.filterProp.untilFloor = item[1];
            this.filtering();
        })

    }

    initFloorsF() {
        const floorsNumber = this.initialFloors.map(floor => {
            return floor.number;
        })

        floorsNumber.sort((a: any, b: any) => {
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
        });
        return floorsNumber;
    }

    filtering() {
        /*const filteredFrools = this.initialFloors.map(floor => ({
            ...floor,
            flats: floor.flats.filter(flat => {
                        const statusCondition = (this.filterProp.status !== "" && this.filterProp.status !== "remove-status") ? flat.status === this.filterProp.status : true;
                        const prototypeCondition = this.filterProp.currentPrototype ? flat.prototypeName === this.filterProp.currentPrototype : true;
                        const roomNumbersCondition = this.filterProp.numRooms ? flat.numberOfRooms === this.filterProp.numRooms : true;
                        let floorNumberCondition = true;
                        if ((this.filterProp.fromFloor || this.filterProp.fromFloor === 0) &&
                                (this.filterProp.untilFloor || this.filterProp.untilFloor === 0) &&
                                typeof this.filterProp.untilFloor !== 'string') {
                            floorNumberCondition = flat.floorNumber >= this.filterProp.fromFloor && flat.floorNumber <= this.filterProp.untilFloor;
                        } else if (typeof this.filterProp.untilFloor === 'string') {
                            floorNumberCondition = true; // Если untilFloor строка, фильтр по этажу не применяется
                        }
                        return statusCondition && prototypeCondition && roomNumbersCondition && floorNumberCondition;
                    }
            )
        })).filter(floor => floor.flats.length > 0);
        this.floors = filteredFrools;
        this.dataService.saveItemsToFilter(this.floors);*/

        this.filteredFlats = this.allFlats.filter(flat => {
            const statusCondition = (this.filterProp.status !== "" && this.filterProp.status !== "remove-status") ? flat.status === this.filterProp.status : true;
            const prototypeCondition = this.filterProp.currentPrototype ? flat.prototypeName === this.filterProp.currentPrototype : true;
            const roomNumbersCondition = this.filterProp.numRooms ? flat.numberOfRooms === this.filterProp.numRooms : true;
            let floorNumberCondition = true;
            if ((this.filterProp.fromFloor || this.filterProp.fromFloor === 0) &&
                    (this.filterProp.untilFloor || this.filterProp.untilFloor === 0) &&
                    typeof this.filterProp.untilFloor !== 'string') {
                floorNumberCondition = flat.floorNumber >= this.filterProp.fromFloor && flat.floorNumber <= this.filterProp.untilFloor;
            } else if (typeof this.filterProp.untilFloor === 'string') {
                floorNumberCondition = true; // Если untilFloor строка, фильтр по этажу не применяется
            }
            return statusCondition && prototypeCondition && roomNumbersCondition && floorNumberCondition;
        })
        this.dataService.saveItemsToFilter(this.filteredFlats);
    }

    resizeFloorDrawing() {
        const holder = document.getElementsByClassName('build-content2')
        const holderWidth = holder[0].clientWidth;
        const buiding = holder[0].getElementsByClassName('building-top')
        const buidingWidth = buiding[0].clientWidth;
        this.widthDragZone = holderWidth - buidingWidth - 145;
        //console.log('this.widthDragZone', this.widthDragZone);
    }

    trackById(index: number, item: any) {
        return item.id;
    }

    showFloorPlanF(floorId) {
        this.selectedFloorId = floorId;
        const flatsByFloorId = this.allFlats.filter(flat => flat.floorId === floorId);
        this.dataService.currentBuild(flatsByFloorId);
        this.dataService.showFloorPlanInProject(floorId);
    }

    ngOnDestroy() {
        this.roomsFilterSubscription && this.roomsFilterSubscription.unsubscribe();
        this.prototypeSubscription && this.prototypeSubscription.unsubscribe();
        this.flatStatusSubscription && this.flatStatusSubscription.unsubscribe();
        this.floorsNumbersSubscription && this.floorsNumbersSubscription.unsubscribe();
        this.routeUrlSubscription && this.routeUrlSubscription.unsubscribe();
        this.refreshTokenSubscription && this.refreshTokenSubscription.unsubscribe();
        this.getAccessTokenSubscription && this.getAccessTokenSubscription.unsubscribe();
        this.queryDataSubscription && this.queryDataSubscription.unsubscribe();
    }

    @HostListener('window:resize') onWindowResize() {
        //debounce resize, wait for resize to finish before doing stuff
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout((() => {
            if (document.getElementsByClassName('floor-gallery').length > 0 && document.getElementsByClassName('floor-gallery') !== undefined) {
                this.resizeFloorDrawing();
            }
        }).bind(this), 100);
    }


    protected readonly event = event;
}
